<app-toaster-item
  *ngFor="let toast of toasterService.toast$ | async; let i=index"
  [toast]="toast"
  [i]="i"
></app-toaster-item>
